import SlimSelect from 'slim-select';

export function initEventListFilter(scope: Document | HTMLElement = document) {
  initSlimSelect();
}

function initSlimSelect() {
  const countrySelectElement: HTMLSelectElement | null = document.querySelector('.js-countryFilter');
  const eventListItems: NodeListOf<HTMLElement> = document.querySelectorAll('.js-eventListItem');
  const hideClass = 'hide';

  if (countrySelectElement) {
    const countryFilter = new SlimSelect({
      select: countrySelectElement,
      showSearch: false,
      allowDeselect: true,
      deselectLabel: '<div class="filter__deselect"><i class="icon icon--x" aria-hidden="true"></i></div>',
    });

    countrySelectElement.addEventListener('change', () => {
      const value = countryFilter.selected();

      if (value !== '') {
        eventListItems.forEach((item) => {
          if (item.dataset.country !== value) {
            item.classList.add(hideClass);
          } else {
            item.classList.remove(hideClass);
          }
        });
      } else {
        eventListItems.forEach((item) => {
          item.classList.remove(hideClass);
        });
      }
    });
  }
}
